export enum TimelineStatusEnum {
    On = 1,
    Out,
    Warning,
    WithoutTimeline
}

export enum ClaimFileOriginTypeEnum {
    Request,
    Response
}
    
export enum ClaimPersonTypeEnum
{
    Claimant,
    Affected,
    Both
}

export enum ClaimProfessionalRoleEnum
{
    Implicated = 1,
    Informant
}